<template>
  <v-container>
    <v-toolbar color="primary" dark>
      <v-toolbar-title dark>Партия</v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-slot:extension>
        <v-tabs fixed-tabs color="primary" active-class="active-tab">
          <v-tabs-slider color="#FDE700"></v-tabs-slider>
          <v-tab ref="history_list" key="history_list" :to="{ name: 'party_history_list' }"
            >История
          </v-tab>
          <v-tab key="program_list" :to="{ name: 'party_program_list' }">Программа</v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-row column>
      <v-col cols="12">
        <router-view
          name="party"
          :site_key="$attrs.site_key"
          :site_title="$attrs.site_title"
        ></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'party',
  mounted() {
    this.$refs.history_list.click({})
  },
  update() {
    this.$refs.history_list.click({})
  },
}
</script>
